import React from 'react';
import Html from 'react-pdf-html';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 11,
        marginTop: '5px',
        fontWeight:'bold'
    },
    container:{
        padding:'3px',
        flexDirection: 'row',
        border:'1px #DDD solid',
        // borderRadius:'5px',
        fontWeight:'normal',
        minHeight:'60px'
    },
    text:{
        fontSize: 10,
        whiteSpace: 'pre-line',
    }
  });

  const OrderProductionDescription = ({data}) => (
    <>
        <Text style={styles.reportTitle}>INFORMAÇÕES ADICIONAIS</Text>
        <View style={styles.container}>
            <Text><Html style={styles.text}>{
                (typeof data.orderProduction?.observation !== 'undefined' && data.orderProduction?.observation !== null) 
                    ? data.orderProduction?.observation.split('\n').join("<br/>")
                    : ''
                }</Html></Text>
        </View>
    </>
  );
  
  export default OrderProductionDescription